import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { cssVar } from '../utils/cssVar';
import Spinner from '../shared/Spinner';
import flatten from 'flat';
import { camelCasePattern, toKebabCase } from '../utils';
import _pick from 'lodash/pick';
import { setTemplate } from '../utils/template';

import as from '../../external/01/vars.json';
import kl from '../../external/04/vars.json';
import ka from '../../external/05/vars.json';
import kac from '../../external/06/vars.json';

function importVars(id) {
  switch (id) {
    case '04':
      return kl;
    case '05':
      return ka;
    case '06':
      return kac;
    default:
      return as;
  }
}

function applyCssVars(vars) {
  const flattened = flatten(_pick(vars, ['theme', 'ga', 'gtm']));
  for (const [key, value] of Object.entries(flattened)) {
    let transKey = toKebabCase(key, '.');
    transKey = toKebabCase(transKey, camelCasePattern, true);
    if (transKey && value) {
      cssVar(transKey, value);
    }
  }
}

const VariablesContext = createContext(null);

export const useVariables = () => useContext(VariablesContext);

export const VariablesProvider = ({ children }) => {
  const [vars, setVars] = useState(null);

  useEffect(() => {
    setTemplate();
    const templateId = window.template ?? '01';
    const loaded = importVars(templateId);
    applyCssVars(loaded);
    setVars(loaded);
  }, []);

  const isLoading = useMemo(
    () => !vars || Object.keys(vars).length === 0,
    [vars]
  );

  return (
    <Spinner spinning={isLoading} size="large" flow="block">
      <VariablesContext.Provider value={vars}>
        {children}
      </VariablesContext.Provider>
    </Spinner>
  );
};